import type { OrderInfoSchema } from "@/components/order/OrderSchema";
import type { BookingInfoSchema } from "@/components/booking/BookingSchema";
import { useTheme } from "@/components/theme-provider";
import { CalendarCheck2 } from "lucide-react";

const loopColors = {
  light: {
    0: "#f8fafc",
    1: "#f1f5f9",
    2: "#e2e8f0"
  },
  dark: {
    0: "#3f3f46",
    1: "#3f3f46",
    2: "#3f3f46"
  }
};

let now = new Date();
now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
export function Booking({ order, schedule, loop, day, onClick }: { order?: OrderInfoSchema | null; schedule?: BookingInfoSchema[], loop: number, day: Date, onClick?: (bookedSlot: BookingInfoSchema) => void }) {

  const { theme } = useTheme();
  const resolvedTheme = theme === 'system' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : theme;
  const color = loopColors[resolvedTheme][loop];
  const orderColor = resolvedTheme === 'light' ? '#b8d1db' : '#052a3b';
  const orderForDay = order && new Date(order.orderBegin) <= day && new Date(order.orderEnd) >= day ? order : null;
  let bookedSlot = null;
  let daysDiff = 0;

  // if(!(day.getDate() == 27 && day.getMonth() == 3))
  //   return;

  if (orderForDay) {
    const bookedSlots = schedule?.filter((s) => new Date(s.bookingBegin) <= day && new Date(s.bookingEnd) >= day);

     
    const assignedSlot = bookedSlots?.filter(s => s.assignedLoop == loop);

 


    if(assignedSlot && assignedSlot.length > 0)
      bookedSlot = assignedSlot[0];
    else
    {
      const unassignedSlot = bookedSlots?.filter(s => s.assignedLoop == null && (new Date(s.bookingBegin) <= day));
   
        //  if(day.getDate() == 27 && loop == 1)
        // {
        //   console.log(bookedSlots?.filter(s => s.assignedLoop == null ));
        //   console.log("slots",bookedSlots, day, unassignedSlot);
        //   //console.log(bookedSlot, (bookedSlot != null && (new Date(bookedSlot.bookingBegin).toDateString() === day.toDateString() || day.getDay() === 1)), new Date(bookedSlot.bookingBegin).toDateString() ,day.toDateString());
        // }


      bookedSlot = unassignedSlot && unassignedSlot.length > 0 ? unassignedSlot[0] : null;
      if(bookedSlot)
      {
        bookedSlot.assignedLoop = loop;
       
      }
       
    }

//     if(day.getDate() == 26 && day.getMonth() == 0)
// {
//console.log(day, orderForDay, loop,schedule, bookedSlots, bookedSlot);
// if(bookedSlot)

// console.log(bookedSlot, (bookedSlot != null && (new Date(bookedSlot.bookingBegin).toDateString() === day.toDateString() || day.getDay() === 1)));
// }


    if (bookedSlot) {
      const bookDate = new Date(bookedSlot?.bookingEnd);
      //strip time
      bookDate.setHours(0, 0, 0, 0);
      daysDiff =
        (bookDate.getTime() - day.getTime()) / (1000 * 60 * 60 * 24)

    }
    else
      daysDiff = 0;

    if(day.getDay() == 0)
    daysDiff = 1;
      else
    daysDiff = Math.min(daysDiff + 1, 8 - day.getDay());

  }

  const loopClass = Number.isInteger(loop) ? `loop-${loop}` : 'loop-unknown';
  return orderForDay ? (
    // Render the booking if available

    <td
      style={{ backgroundColor: (bookedSlot == null)?orderColor:color, position: 'relative' }}
      key={`${day}-${orderForDay.orderId}`}
      className={`calendarDropZone ${bookedSlot == null && day >= now ? 'cursor-pointer' : ''}`}
      title={`${bookedSlot == null && day >= now ? 'Buchung hinzuzufügen' : ''}`}
      data-bookingid={orderForDay.orderId}
      {...(bookedSlot == null && day >= now
        ? {
          onClick: () => onClick && onClick({
            bookingId: null,
            spotId: "",
            spotName: "",
            bookingBegin: day,
            bookingEnd: new Date(orderForDay.orderEnd),
            orderId: orderForDay.orderId,

            statusId: 1,//new
            length: 0
          })
        }
        : {})}
    >

      {(bookedSlot != null && (new Date(bookedSlot.bookingBegin).toDateString() === day.toDateString() || day.getDay() === 1)) ? (

        <div
          key={bookedSlot?.bookingId}
          className={`day-event ${loopClass}`}
          data-loop={Number.isInteger(loop) ? loop : 'unknown'}
          style={{ width: `${daysDiff * 100 - 3/daysDiff}%` }}
          onClick={ev => {
            ev.stopPropagation();
            onClick && onClick(bookedSlot as BookingInfoSchema);
          }}
        >
          {
            `${bookedSlot?.spotName + ' (' + new Date(bookedSlot?.bookingBegin).toLocaleDateString() + " - " + new Date(bookedSlot?.bookingEnd).toLocaleDateString() + ')'}`
          }
        </div>) : null}

        {bookedSlot == null && day >= now ? (
          <div className="add-booking-indicator ">
            <CalendarCheck2 size={16} className="mr-auto ml-auto"/>
          </div>
         ) : null}
    </td>
  ) : (

    <td key={`${day}-${Math.random()}`}></td>)
}